module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.2809/js/img/middle-blob.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/middle-blob.svg
// module id = 736
// module chunks = 3 4